import { useCallback, useEffect, useState } from 'react';
import { Modal } from '../../modal/modal-old.js';
import BinaryQuestion from '~/components/binary-question';

const WeSpinClipAddClipModal = ({ openModal, hideModalCallback, saveClipCallback, translations }) => {
	const [clipUrl, setClipUrl] = useState('');

	const onUrlChange = useCallback(
		event => {
			setClipUrl(event.target.value);
		},
		[setClipUrl]
	);

	useEffect(() => {
		if (!openModal) {
			setClipUrl('');
		}
	}, [openModal]);

	const validate = () => {
		// Allow any clip url for now
		return true;
	};

	const saveClipInternalCallback = useCallback(async () => {
		saveClipCallback({ url: clipUrl });
		setClipUrl('');
		hideModalCallback();
	}, [saveClipCallback, clipUrl, setClipUrl, hideModalCallback]);

	return (
		<Modal show={openModal} blurBg position="fixed">
			<div className="form">
				<BinaryQuestion
					shouldOpenBinary
					title={translations.WE_SPIN_CLIP_MODAL_TITLE}
					text={translations.WE_SPIN_CLIP_MODAL_TEXT}
					yesText={translations.WE_SPIN_CLIP_MODAL_OK}
					noText={translations.WE_SPIN_CLIP_MODAL_CANCEL}
					onYesClick={saveClipInternalCallback}
					onOutsideClick={hideModalCallback}
					onNoClick={hideModalCallback}
					onChange={onUrlChange}
					inputValue={clipUrl}
					renderInParent
					hasInput
					inputType="text"
					forceFocus
					validationMessage={translations.WE_SPIN_CLIP_MODAL_VALIDATION_ERROR}
					placeholder={translations.WE_SPIN_CLIP_MODAL_INPUT_PLACEHOLDER}
					enableInputValidation
					customValidate={validate}
				/>
			</div>
		</Modal>
	);
};

export default WeSpinClipAddClipModal;
